/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WarningDTO } from './warning-dto';
import { RegolaMatchDTO } from './regola-match-dto';


export interface TariffaMensaSimulazioneDTO { 
    contributo?: number;
    costo_pasto?: number;
    regola_match?: RegolaMatchDTO;
    matched?: boolean;
    sconto_multifiglio_applicato?: boolean;
    warnings?: Array<WarningDTO>;
}

